export default __webpack_public_path__ + "static/museo-sans-regular-f01af89098fb3249c47957601cf49d0e.woff";